import { wrapFontFamily } from 'common/components/entities/Text/utils'
import { usePage } from 'publisher/store'
import pageSelectors from 'publisher/store/page/pageSelectors'
import React, { PropsWithChildren } from 'react'
import PageUi from './ui/PageUi'

export const BookingCalendarPreviewPage = ({ children }: PropsWithChildren) => {
  const globalTextFontProperties = usePage(
    pageSelectors.getGlobalFontProperties,
  )
  return (
    <PageUi
      $textFontFamily={wrapFontFamily(globalTextFontProperties.fontFamily)}
      $textFontWeight={globalTextFontProperties.fontWeight}
      $textFontStyle={globalTextFontProperties.fontStyle}
    >
      {children}
    </PageUi>
  )
}
